// Copyright (c) 2017 Deere & Company

import Link from '@deere/cps-it.warranty-model-factory/lib/link';
import t from 'tcomb';

const Links = t.list(Link, 'Links');

export const getDefaultState = () => new Links([]);

export default Links;



// WEBPACK FOOTER //
// ./src/shared/state/links.js